import React, { useEffect, useState } from "react"
import { Col, Row, ButtonGroup } from "react-bootstrap"
import Select from "react-select"
import { useLocation } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import {
  dateFormat,
  getTodayDate,
  numberFormat,
  selectDropdownStyle,
  startOfMonth,
  endOfMonth,
} from "../../../Helpers/Utils/Common"
import DatePicker from "react-datepicker"
import Moment from "moment"
import { searchExpenseReport } from "./../../../Helpers/apiCalls/ExpensesReports/ExpenseReportApi"
import { getType } from "../../../Helpers/apiCalls/expensetypesApi"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import * as XLSX from "xlsx"
import downloadIcon from "../../../Assets/Images/download_icon.png"

export default function ExpenseRegister() {
  const location = useLocation()
  const dateToday = getTodayDate()
  const dateFrom = location.state?.dateFrom
  const dateTo = location.state?.dateTo
  const [summary, setSummary] = useState({})
  const [excelData, setExcelData] = useState([])
  const [inactive, setInactive] = useState(true)

  const headers = [
    "EXPENSE TYPE",
    "DOC NO.",
    "DOC TYPE",
    "DATE",
    "SUPPLIER",
    "AMOUNT DUE",
    "PAID AMOUNT",
    "BALANCE",
  ]

  const thirtyDaysBefore = (givenDate) => {
    const newDate = new Date(givenDate)
    newDate.setDate(newDate.getDate() - 30)
    newDate.setTime(newDate.getTime() - 1)
    return newDate
  }
  const getMonthFromUrl = () => {
    const searchParams = new URLSearchParams(location.search)
    return searchParams.get("month")
  }
  const defaultStartDate = thirtyDaysBefore(dateToday)
  const month = getMonthFromUrl()
  const startDate = month ? startOfMonth(month) : defaultStartDate
  const endDate = month ? endOfMonth(month) : new Date()

  const [filterConfig, setFilterConfig] = useState({
    date_from: startDate,
    date_to: endDate,
    expense_type: "",
    expense_type_value: {
      placeholder: "All Expenses Type",
      label: "All",
      value: "",
    },
    doc_type_value: {
      placeholder: "All Doc Type",
      label: "All",
      value: "",
    },
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const [showLoader, setShowLoader] = useState(false)
  const [noData, setNoData] = useState(false)
  const [allExpenseTypes, setAllExpenseTypes] = useState([])
  const [tableData, setTableData] = useState([])

  const handleTypeFilter = (e) => {
    console.log(e)
    if (e.name === "doc_type") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          doc_type_value: {
            label: e.label,
            value: e.value,
          },
        }
      })
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          expense_type_value: {
            label: e.label,
            value: e.value,
          },
        }
      })
    }
  }

  function handleExport() {
    const rows = excelData
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" })
    XLSX.writeFile(workbook, "Expenses.xlsx", {
      compression: true,
    })
  }

  function ContractBtn(row) {
    return (
      <button
        type="button"
        className="button-secondary table-button mx-3"
        onClick={() => handleViewContract(row.doc_id, row.doc_type)}
      >
        {row.doc_id}
      </button>
    )
  }

  function handleViewContract(id, doc_type) {
    if (doc_type === "Receive") {
      window.open("/purchaseinvoices/print/" + id, "_blank")
    } else if (doc_type === "Petty Cash") {
      window.open("/pettycash/cashout/" + id, "_blank")
    } else if (doc_type === "Supplies Expense") {
      window.open("/se/purchaseinvoices/print/" + id, "_blank")
    }
  }

  useEffect(() => {
    async function fetchData() {
      setShowLoader(true)
      setTotalItems(0)
      const response = await searchExpenseReport(filterConfig)

      if (response.error) {
        setTableData([])
        setNoData(true)
      } else {
        setSummary(response.data.summary)
        var expense = response.data.data.map((data) => {
          var info = data
          info.doc_date = dateFormat(data.doc_date)
          info.balance = numberFormat(data.balance)
          info.paid_amount = numberFormat(data.paid_amount)
          info.amount_due = numberFormat(data.amount_due)
          return info
        })

        var excelData = response.data.data.map((data) => {
          return {
            expense_type: data.expense_type,
            doc_no: data.doc_id,
            doc_type: data.doc_type,
            doc_date: dateFormat(data.doc_date),
            supplier: data.supplier,
            amount_due: data.amount_due,
            paid_amount: data.paid_amount,
            balance: data.balance,
          }
        })

        setTableData(expense)
        setExcelData(excelData)
        setTotalItems(response.data.size)
      }
      setShowLoader(false)
    }

    fetchData()
  }, [filterConfig, currentPage])

  useEffect(() => {
    async function fetchAllExpenseTypes() {
      setTotalItems(0)
      const response = await getType()
      console.log(response.data)
      if (response.data) {
        const res = response.data.map((row) => {
          var info = row
          info.value = row.id
          info.label = row.name
          return info
        })
        setAllExpenseTypes(res)
        setTotalItems(response.data.size)
      }
    }

    fetchAllExpenseTypes()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"EXPENSES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EXPENSES{" "}
            </h1>
          </Col>
        </Row>

        <div className="tab-content __table-container">
          {/* filters */}
          <div className="mb-3" />
          <span className="mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                name="type"
                className="dropsearch-filter"
                classNamePrefix="react-select"
                styles={selectDropdownStyle}
                // value={allExpenseTypes.map(
                //   (item) => item.id === filterConfig.expense_type
                // )}
                value={filterConfig.expense_type_value}
                options={[{ label: "All", value: null }, ...allExpenseTypes]}
                onChange={handleTypeFilter}
              />
            </Col>
             <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                name="type"
                className="dropsearch-filter mt-2 mt-lg-0"
                classNamePrefix="react-select"
                placeholder="Doc Type..."
                styles={selectDropdownStyle}
                value={filterConfig.doc_type_value}
                options={[
                  { label: "All", value: "", name: "doc_type" },
                  { label: "Purchases", value: "Purchases", name: "doc_type" },
                  {
                    label: "Petty Cash",
                    value: "Petty Cash",
                    name: "doc_type",
                  },
                  {
                    label: "Other Expenses",
                    value: "Other Expenses",
                    name: "doc_type",
                  },
                ]}
                onChange={handleTypeFilter}
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                value={dateFormat(filterConfig.date_from)}
                name="date_from"
                placeholder={Moment().format("MMMM DD, YYYY")}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                value={dateFormat(filterConfig.date_to)}
                name="date_to"
                placeholderText={Moment().format("MM/DD/YYYY")}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col> 
          </Row>
          <div className=" PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 mt-2 ps-label">
              TOTAL AMOUNT DUE:{" "}
              {summary.total_amount_due === "0.00"
                ? "0.00"
                : summary.total_amount_due}
            </span>

            <span className="me-4 ml-4 mt-2 ps-label">
              Total Paid Amount:{" "}
              {summary.total_paid_amount === "0.00"
                ? "0.00"
                : summary.total_paid_amount}
            </span>

            <span className="me-4 ml-4 mt-2 ps-label">
              Total Balance:{" "}
              {summary.total_balance === "0.00"
                ? "0.00"
                : summary.total_balance}
            </span>
          </div>
          <div className="mb-2" />
          <TableWithDynamicPagination
            tableHeaders={[
              "EXPENSE TYPE",
              "DOC NO.",
              "DOC TYPE",
              "DATE",
              "SUPPLIER",
              "AMOUNT DUE",
              "PAID AMOUNT",
              "BALANCE",
            ]}
            headerSelector={[
              "expense_type",
              "",
              "doc_type",
              "doc_date",
              "supplier",
              "amount_due",
              "paid_amount",
              "balance",
            ]}
            tableData={tableData}
            newTabBtn={(row) => ContractBtn(row)}
            showLoader={showLoader}
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
          />
          <div className="mb-2" />
        </div>
        <Row className="d-flex flex-row justify-content-end mt-3">
          <Col md={2}>
            <button
              type="button"
              className="primary-btn"
              onClick={handleExport}
            >
              <span className="me-2">
                <img width={20} height={20} src={downloadIcon} alt=""></img>
              </span>
              Download
            </button>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  )
}
